export default __webpack_public_path__ + "static/media/box-6.090113c4.png";